var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99956 11.7987L10.7662 13.472C11.2729 13.7787 11.8929 13.3253 11.7596 12.752L11.0262 9.60533L13.4729 7.48533C13.9196 7.09866 13.6796 6.36533 13.0929 6.31866L9.87289 6.04533L8.61289 3.07199C8.38623 2.53199 7.61289 2.53199 7.38623 3.07199L6.12623 6.03866L2.90623 6.31199C2.31956 6.35866 2.07956 7.09199 2.52623 7.47866L4.97289 9.59866L4.23956 12.7453C4.10623 13.3187 4.72623 13.772 5.23289 13.4653L7.99956 11.7987Z",
    fill: "#FFAC2F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStart);
export default __webpack_public_path__ + "static/media/review_start.4cba9af42c796f2ea3b1fbe2b64557f3.svg";
export { ForwardRef as ReactComponent };